import React from 'react';

export function CompanyURL(props) {
	return (
		<tr style={{ verticalAlign: 'middle' }}>
			<td
				style={{
					padding: '5px 0 0',
					fontSize: '11px',
					color: '#808080',
					lineHeight: '15px',
					textDecoration: 'none'
				}}
			>
				<a
					href={`https://${props.url}/`}
					target="_blank"
					rel="noopener noreferrer"
					color="#808080"
					style={{
						textDecoration: 'none',
						color: '#808080'
					}}
				>
					<span>{props.url}</span>
				</a>
			</td>
		</tr>
	);
}
